import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader } from "@/store/loaderSlice";
import HocHead from "@/Components/HigherOrderComponent/HocHead";
import dynamic from "next/dynamic";
const CaseStudy = dynamic(() => import("./case-study"));
const CaseNew = dynamic(() => import("../case-studies-detail/case-new"));
const FullPageLoader = dynamic(() => import("@/Components/FullPageLoader"));

interface Seo {
  title?: string;
  description?: string;
  keywords?: string;
  [key: string]: any;
}

interface CaseStudyAttributes {
  slug: string;
  seo?: Seo;
  [key: string]: any;
}

interface CaseStudyResponse {
  data: {
    attributes: CaseStudyAttributes;
  }[];
}

// Props type
interface CaseStudyPageProps {
  slug: string;
  data: CaseStudyResponse;
}

// Redux RootState type (adjust to match your store)
interface RootState {
  loader: {
    loading: boolean;
  };
}

// Component map
const components: Record<string, React.ComponentType<any>> = {
  "case-studies": CaseStudy,
  "case-study-new": CaseNew,
};

const CaseStudyPage: React.FC<CaseStudyPageProps> = (props) => {
  const { slug, data: sdata } = props;

  const Component =
    slug === "case-studies" ? components[slug] : components["case-study-new"];

  const loading = useSelector((state: RootState) => state.loader.loading);
  const dispatch = useDispatch();

  const data = sdata?.data?.[0]?.attributes;
  const seo = data?.seo;

  useEffect(() => {
    dispatch(hideLoader());
  }, [dispatch]);

  return (
    <>
      {seo && <HocHead seo={seo} />}
      {loading && <FullPageLoader />}
      <Component data={data} />
    </>
  );
};

export default CaseStudyPage;
